import(/* webpackMode: "eager" */ "/var/www/one/app/license/page.tsx");
